import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useParams, useSearchParams } from "react-router-dom";
import CategoryHeader from "../../Components/Category/CategoryHeader";
import CardProductsContainer from "../../Components/Products/CardProductsContainer";
import Pagination from "../../Components/Utilities/Pagination";
import ViewAllProductByBrandHook from "../../hook/product/ViewAllProductByBrandHook";

import { Helmet } from "react-helmet";
import SideFilter from "../../Components/Utilities/SideFilter";
import ViewSearchProductHooks from "../../hook/product/ViewSearchProductHooks";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";

const ProductsByBrands = () => {
  const { id } = useParams();
  const [, , , brandById, settingsRes] = ViewAllProductByBrandHook(id);
  const [
    items,
    pagination,
    onPress,
    getProduct,
    result,
    offers,
    selectedCategorySearch,
    selectedBrandSearch,
    search,
    onChangeSetMinPrice,
    onChangeSetMaxPrice,
    ,
    ,
    loadingSpinner,
    ,
    minPrice,
    maxPrice,
    searchBrand,
    ,
    searchCategories
  ] = ViewSearchProductHooks("" , undefined,undefined,id);

  const[searchParams,setSearchParams]=useSearchParams();
  const [waitTime, setWaitTime] = useState(true);

  useEffect(()=>{
      setWaitTime(true);
  
      const timeoutId = setTimeout(() => {
        setWaitTime(false);
        // dispatch(EndWaitTimeForHomePage());
      }, 2000);
  
      clearTimeout(timeoutId);
    },[searchParams]);

    setTimeout(() => {
      setWaitTime(false);
      // dispatch(EndWaitTimeForHomePage());
    }, 2000);

  
  let hideCategory = false;
  let hideBrands = true;
  if (pagination) var pageCount = pagination;
  else pageCount = 0;

  // console.log('items');
  // console.log(items);
  console.log('settingsRes?.data?.titleAr');
  console.log(settingsRes?.data?.titleAr);
  //{`  ${items[0]?.brand?.nameAr || ' '} ${items[0] ? '-' : ' '} ${settingsRes?.data?.titleAr}`}
  return (
    <div style={{ minHeight: "670px" }}>

      <head>
        <title> البراندات</title>
      </head>

      <CategoryHeader />
      <Container className="pt-4 pb-2">
        <div className="d-flex align-items-center" style={{ gap: '20px' }}>
          {brandById?.logo && (
            <div className="premium-brand-logo">
              <img
                src={brandById?.logo}
                alt="Brand Logo"
              />
            </div>
          )}
          <div>
            <h1 className="premium-page-title">{brandById?.nameAr}</h1>
            <p className="premium-page-subtitle text-muted mb-0">تصفح أحدث المنتجات والعروض المميزة</p>
          </div>
        </div>
        <hr className="mt-4 mb-2" style={{ borderColor: "rgba(0,0,0,0.05)" }} />
      </Container>
      <Container>
      <Row className="d-flex justify-content-center">
      <Col sm="2" xs="2" md="2" className="d-flex ">
        <SideFilter
          props={{
            selectedCategorySearch,
            selectedBrandSearch,
            search,
            onChangeSetMinPrice,
            onChangeSetMaxPrice,
            hideCategory,
            hideBrands,
            searchCategories
          }}
        />
      </Col>
      <Col md="10" sm="10">
        {loadingSpinner === true ? (
          <LoadingSpinner />
        ) :
        <>
         <div style={{ display: waitTime == true ? 'block' : 'none' }}>
                  <LoadingSpinner />
          </div>
          <div style={{ display: waitTime == true ? 'none' : 'block' }}>
          <CardProductsContainer products={items} title="" btntitle="" />
          </div>
        </>
         }
      </Col>
    </Row>
       {pagination && <Pagination pageCount={pageCount} onPress={onPress} />} 
      </Container>
    </div>
  );
};

export default ProductsByBrands;
